import React from 'react';
import { useDispatch } from 'react-redux';
import { Field, Form as FinalForm } from 'react-final-form';
import { Form, Button } from 'semantic-ui-react';
import { getUserByPhone } from 'state/resetPhone/actions';
import ValidatedFormInput from 'components/ValidatedFormInput';

function FetchUserDetailForm() {
  const dispatch = useDispatch();

  const onSubmit = values => {
    dispatch(getUserByPhone(values));
  };

  return (
    <div>
      <FinalForm
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <label>Phone Number</label>
            <Field name="phoneNumber" component={ValidatedFormInput} />
            <Button content="Search" primary />
          </Form>
        )}
      />
    </div>
  );
}

export default FetchUserDetailForm;
